export default function generateCombinedMediaQuery(currentMediaQuery, nestedMediaQuery) {
  if (currentMediaQuery.length === 0) {
    return nestedMediaQuery;
  }

  return currentMediaQuery + " and " + nestedMediaQuery;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/generateCombinedMediaQuery.js
// module id = 722
// module chunks = 0